export enum AccountTabs {
    PersonalDetails = 'personal-details',
    ProfessionalDetails = 'professional-details',
    ContactDetails = 'contact-details',
    PasswordChange = 'password-change',
    TaxDetails = 'tax-details',
    ContactPreferences = 'contact-preferences',
    AuthenticatorApp = 'authenticator-app',
    PayoutDetails = 'payout-details',
}
